import { useContent } from '@/services/siteData';
import { Seo } from '@/components/Seo';

type LegalKey = 'privacy' | 'cookie';

export function LegalPage({ pageKey }: { pageKey: LegalKey }) {
  const { legal } = useContent();
  const page = legal?.[pageKey] ?? {
    title: pageKey === 'privacy' ? 'Privacy Policy' : 'Cookie Policy',
    body: ['Content to be provided.'],
  };

  return (
    <div className="page-fade">
      <Seo title={page.title} description={`${page.title} for Didier's Patisserie.`} path={`/${pageKey}`} />
      <div className="page-head">
        <h1>{page.title}</h1>
      </div>
      <div className="story">
        {page.body.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
}
